import { render, staticRenderFns } from "./recordHistory.vue?vue&type=template&id=1ee64d0f&"
import script from "./recordHistory.vue?vue&type=script&lang=js&"
export * from "./recordHistory.vue?vue&type=script&lang=js&"
import style0 from "./recordHistory.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports